export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:4000/api/v1';

export interface ApiErrorPayload {
  code: string;
  message: string;
  details?: Record<string, unknown>;
}

export class ApiClientError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly status?: number,
    public readonly details?: Record<string, unknown>
  ) {
    super(message);
  }
}

async function readApiError(response: Response): Promise<ApiErrorPayload> {
  try {
    return (await response.json()) as ApiErrorPayload;
  } catch {
    return {
      code: 'API_HTTP_ERROR',
      message: 'Não foi possível concluir a operação.',
    };
  }
}

export async function apiRequest<T>(
  path: string,
  accessToken: string,
  init: RequestInit = {}
): Promise<T> {
  let response: Response;

  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      ...init,
      headers: {
        Accept: 'application/json',
        ...(init.body ? { 'Content-Type': 'application/json' } : {}),
        Authorization: `Bearer ${accessToken}`,
        ...init.headers,
      },
    });
  } catch {
    throw new ApiClientError(
      'API_INDISPONIVEL',
      'API indisponível. Confirme se o backend está em execução.'
    );
  }

  if (!response.ok) {
    const error = await readApiError(response);
    throw new ApiClientError(
      error.code,
      error.message,
      response.status,
      error.details
    );
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return (await response.json()) as T;
}

export async function apiDownload(path: string, accessToken: string): Promise<Blob> {
  let response: Response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      headers: { Accept: '*/*', Authorization: `Bearer ${accessToken}` },
    });
  } catch {
    throw new ApiClientError('API_INDISPONIVEL', 'API indisponível. Confirme se o backend está em execução.');
  }
  if (!response.ok) {
    const error = await readApiError(response);
    throw new ApiClientError(error.code, error.message, response.status, error.details);
  }
  return response.blob();
}
